import { DASHBOARD_ORIGIN } from 'config';

/**
 * Bare-root endpoint on the Django origin — deliberately NOT under `/api/`.
 * It is `@csrf_exempt` and POST-only, and expects ordinary form encoding.
 */
export const HANDOFF_URL = `${DASHBOARD_ORIGIN}/auth/handoff`;

/**
 * Hand the browser to the dashboard by POSTing a one-time handoff code from an
 * auto-submitting form.
 *
 * A form POST rather than a GET redirect: the code stays out of the URL, out of
 * browser history, and out of every access log between here and Django. Django
 * answers with a 302 to `/dashboard/` on success, or to its sign-in page on any
 * failure (unknown, expired, already-spent or missing code) without saying which.
 *
 * The code is single-use with a 30-second TTL, so this must run immediately after
 * sign-in. Submitting is a top-level navigation: the React app is torn down.
 *
 * Throws if the form cannot be built or submitted; the caller is expected to
 * surface that in the sign-in error UI.
 */
export const submitHandoff = (code: string): void => {
  const form = document.createElement('form');
  form.method = 'POST';
  form.action = HANDOFF_URL;
  form.style.display = 'none';

  const input = document.createElement('input');
  input.type = 'hidden';
  // SEC-041 reads `code`, and accepts `handoff_code` as an alias. Prefer `code`.
  input.name = 'code';
  input.value = code;
  form.appendChild(input);

  if (!document.body) {
    throw new Error('Cannot submit sign-in handoff: document body is unavailable.');
  }

  document.body.appendChild(form);
  form.submit();
};
